<template>
	<form class="contacts__form form">
		<div class="form__inputs">
			<InputSelect :label="'Тема обращения'" :errors="v$.formData.themeId.$errors">
				<template #select>
					<Multiselect
						:can-clear="false"
						:canDeselect="false"
						:placeholder="'Наименование темы сотрудничества'"
						ref="multiselect"
						:label="'name'"
						:value-prop="'id'"
						:options="themes"
						@select="changeTheme" />
				</template>
			</InputSelect>
		</div>
		<div class="form__inputs form__inputs--3">
			<InputText :label="'ФИО'" :placeholder="'Иванов Иван Иванович'" v-model="formData.fullName" :errors="v$.formData.fullName.$errors"/>
			<InputText :label="'E-mail'" :placeholder="'Введите E-mail'" v-model="formData.email" :errors="v$.formData.email.$errors"/>
			<InputText :label="'Телефон'" :placeholder="'+'" :phone="true" v-model="formData.phone" :errors="v$.formData.phone.$errors"/>
		</div>
		<div class="form__inputs">
			<InputText :label="'Комментарий'" :placeholder="'Опишите вопрос/предложение'" v-model="formData.comment" :errors="v$.formData.comment.$errors"/>
		</div>
		<div class="form__submit">
			<button class="form__submit-btn btn btn--color" type="submit" @click.prevent="checkReCaptcha">Отправить</button>
			<div class="form__submit-description">Нажимая кнопку «Отправить», Вы даете согласие на обработку <a target="_blank" :href="staticData.personalLink">персональных данных</a></div>
		</div>
	</form>
</template>

<script>
import InputText from "@/components/base/utils/formElements/InputText.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import Fetch from "@/utils/Fetch";
import objectToFormData from "@/utils/ObjectToFormData";
import { useToast } from "vue-toastification";
import staticData from '@/enums/staticData';
import useVuelidate from "@vuelidate/core";
import {required, helpers, email, minLength, maxLength} from '@vuelidate/validators'
const {withMessage} = helpers


export default {
	name: 'ContactsFeedback',
	components: {InputText,Multiselect,InputSelect},
	props: {
		themes: {
			type: Array,
			default: () => []
		}
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			toast: useToast(),
			formData: {
				themeId: '',
				fullName: '',
				email: '',
				phone: '',
				comment: ''
			}
		}
	},
	computed: {
		staticData() {
			return staticData
		}
	},
	methods: {
		changeTheme(value) {
			this.formData.themeId = value
		},
		async checkReCaptcha(e) {
			e.preventDefault();
			const validated = await this.v$.formData.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				return
			}
			// eslint-disable-next-line no-undef
			grecaptcha.ready(() => {
				// eslint-disable-next-line no-undef
				grecaptcha.execute('6Le-0jsmAAAAANJNzqizBZv0AZCkt7xN3OkDdRCR', {action: 'submit'}).then(async (token) => {
					await this.sendForm(token)
				});
			});
		},
		async sendForm(token) {

			const body = objectToFormData({
				theme: this.formData.themeId,
				fio: this.formData.fullName,
				email: this.formData.email,
				phone: this.formData.phone,
				comment: this.formData.comment,
				token
			})

			let response = await Fetch('feedbacks/add/', {
				method: 'POST',
				body
			})

			if(response.success) {
				this.toast.success('Ваш вопрос успешно отправлен');
				this.clearForm()
			} else {
				this.toast.error(response.message);
			}
		},
		clearForm() {
			for(let item in this.formData) {
				this.formData[item] = ''
			}
			this.v$.$reset()
			this.$refs.multiselect.clear();
		}
	},
	validations() {
		return {
			formData: {
				themeId: {
					required: withMessage("Выберите тему обращения", required),
				},
				fullName: {
					required: withMessage("Заполните ФИО", required),
				},
				email: {
					email: withMessage('Неверный формат электронной почты', email),
					required: withMessage('Заполните E-mail', required),
				},
				phone: {
					required: withMessage("Заполните телефон", required),
					minLength: withMessage("В номере телефона должно быть минимум 8 цифр", minLength(9)),
					maxLength: withMessage("В номере телефона должно быть максимум 15 цифр", maxLength(16)),
				},
				comment: {
					required: withMessage("Заполните комментарий", required),
				},
			}
		}
	},
}
</script>
